import { render, staticRenderFns } from "./LabelAndMessage.vue?vue&type=template&id=4b3ed51c&scoped=true&lang=html&"
import script from "./LabelAndMessage.vue?vue&type=script&lang=js&"
export * from "./LabelAndMessage.vue?vue&type=script&lang=js&"
import style0 from "./LabelAndMessage.vue?vue&type=style&index=0&id=4b3ed51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ed51c",
  null
  
)

export default component.exports